<template>
	<div class="datatable">
		<table :id="id" :class="classObject" :data-filter="filter">
			<thead>
				<tr>
					<th v-if="!!selectable" :style="{ width: '50px' }"></th>
					<th v-if="!!draggable" :style="{ width: '75px' }"></th>
					<datatable-header
						v-for="(item, index) in thead"
						:key="index"
						:item="item"
						:index="index"
						:orderingEnabled="!!draggable ? false : ordering.enabled"
						:ordering="ordering.params"
					></datatable-header>
					<th v-if="!!showActions || !!editable" :style="{ width: '75px' }"></th>
				</tr>
			</thead>
			<datatable-body
				:loading="loading"
				:thead="thead"
				:tbody="tbody"
				:length="paging.length"
				:current="paging.pages.current"
				:orderingEnabled="!!draggable ? false : ordering.enabled"
				:pagingEnabled="!!draggable ? false : paging.enabled"
				:ordering="ordering.params"
				:showActions="showActions"
				:fieldActions="fieldActions"
				:customRender="defs"
				:editRefmodal="editRefmodal"
				:editable="editable"
				:selectable="selectable"
				:draggable="draggable"
			></datatable-body>
			<tfoot v-if="!!editable && !!createUrl" ref="tfoot_create">
				<tr>
					<td :colspan="!!selectable ? thead.length + 2 : thead.length + 1">
						<b>INSERISCI</b>
					</td>
				</tr>
				<tr class="editable">
					<td v-if="!!selectable"></td>
					<td v-if="!!draggable"></td>
					<datatable-form-cell
						v-for="(value, col_index) in thead"
						:key="col_index"
						:colIndex="col_index"
						:col="value"
					></datatable-form-cell>
					<td>
						<div :style="{ display: 'flex' }">
							<btn
								:action="submitFormRow"
								type="success"
								light
								table
								label="Salva"
								:icon="['far', 'plus']"
							/>
						</div>
					</td>
				</tr>
			</tfoot>
		</table>
		<datatable-pagination
			:paging="!!draggable ? false : paging.enabled"
			:pagingInfo="true"
			:itemsCount="tbody.length"
			:length="paging.length"
			:total="paging.pages.total"
			:current="paging.pages.current"
		></datatable-pagination>
	</div>
</template>

<script>
export default {
	data: () => ({
		request: {
			url: '',
			method: 'GET',
			dataSrc: '',
		},
		paging: {
			enabled: true,
			length: 25,
			pages: {
				current: 1,
				total: 1,
			},
		},
		ordering: {
			enabled: true,
			params: [],
		},
		searching: {
			enabled: true,
		},
		filter: {},
		items: [],
		tbody: [],
		loading: false,
	}),
	props: {
		id: {
			type: String,
			default: '',
			required: false,
		},
		hideHeader: {
			type: Boolean,
			default: false,
			required: false,
		},
		showActions: {
			type: Boolean,
			default: true,
			required: false,
		},
		fieldActions: {
			type: String,
			default: 'actions',
			required: false,
		},
		editRefmodal: {
			type: String,
			default: '',
			required: false,
		},
		url: {
			type: String,
			default: '',
			required: false,
		},
		dataSrc: {
			type: String,
			default: '',
			required: false,
		},
		datas: {
			type: Array,
			default: () => [],
			required: false,
		},
		cols: {
			type: Array,
			default: () => [],
			required: false,
		},
		length: {
			type: Number,
			default: 25,
			required: false,
		},
		refTable2: {
			type: String,
			default: '',
			required: false,
		},
		defs: {
			type: Array,
			default: () => [],
			required: false,
		},
		createUrl: {
			type: String,
			default: '',
			required: false,
		},
		editable: {
			type: Boolean,
			default: false,
			required: false,
		},
		selectable: {
			type: String,
			default: '',
			required: false,
		},
		draggable: {
			type: String,
			default: '',
			required: false,
		},
		border: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	computed: {
		classObject: function() {
			return {
				table: true,
				'no-thead': !!this.hideHeader,
				border: !!this.border,
			}
		},
		thead: function() {
			return this.cols.map(element => ({
				title: !!element.title ? element.title : '',
				data: !!element.data ? element.data : null,
				class: !!element.class ? element.class : null,
				responsive: !!element.responsive ? element.responsive : null,
				type: !!element.type ? element.type : 'string',
				typeFormat: !!element.typeFormat ? element.typeFormat : '',
				orderable: typeof element.orderable == 'undefined' ? true : !!element.orderable,
				searchable: typeof element.searchable == 'undefined' ? true : !!element.searchable,
				formType: !!element.formType ? element.formType : 'text',
				formData: !!element.formData ? element.formData : '',
				formHidden: !!element.formHidden ? element.formHidden : false,
				formOptions: !!element.formOptions ? element.formOptions : [],
				formItemLabel: !!element.formItemLabel ? element.formItemLabel : '',
				formItemValue: !!element.formItemValue ? element.formItemValue : '',
				formRequired:
					typeof element.formRequired != 'undefined' ? !!element.formRequired : true,
				formMultiple: !!element.formMultiple ? element.formMultiple : false,
				formNumberMin: !!element.formNumberMin ? element.formNumberMin : null,
				formNumberMax: !!element.formNumberMax ? element.formNumberMax : null,
				formNumberStep: !!element.formNumberStep ? element.formNumberStep : null,
				formReadOnly: !!element.formReadOnly ? element.formReadOnly : false,
			}))
		},
	},
	methods: {
		submitFormRow: function(el) {
			return this.$root.requestPost(
				this,
				this.createUrl,
				this.$root.getParamsFromDiv(this.$refs['tfoot_create']),
				this.submitFormCallback
			)
		},
		submitFormCallback: function(data) {
			this.refreshTable(false)
			this.$root.resetsFromDiv(this.$refs['tfoot_create'])
		},
		updatePager: function() {
			this.paging.length = this.length

			if (this.items.length == 0 || this.tbody.length == 0) {
				this.paging.pages.total = 1
				this.paging.pages.current = 1
			} else {
				let total = Math.ceil(this.tbody.length / this.paging.length)
				this.paging.pages.total = total
				if (this.paging.pages.current > total) {
					this.paging.pages.current = total
				}
			}
		},
		setUrl: function() {
			this.request.url = this.url
			this.request.dataSrc = this.dataSrc
		},
		getProp: function(obj, desc) {
			var arr = desc.split('.')
			while (arr.length && (obj = obj[arr.shift()]));
			return obj
		},
		updateTbody: function() {
			let tbody = []
			if (!!this.items && this.items.length >= 0) {
				tbody = this.items
			}

			for (let field in this.filter) {
				for (let type in this.filter[field]) {
					let value = this.filter[field][type]
					console.log('[FILTER]', field, type, value)
					if (type === 'in') {
						tbody = tbody.filter(item => Vue.filterFieldInclude(item, field, value))
					} else if (type === 'eq') {
						tbody = tbody.filter(item => Vue.filterFieldEquals(item, field, value))
					} else if (type === 'from') {
						tbody = tbody.filter(item => Vue.filterFieldFrom(item, field, value))
					} else if (type === 'to') {
						tbody = tbody.filter(item => Vue.filterFieldTo(item, field, value))
					}
				}
			}
			this.tbody = tbody

			this.updatePager()
		},
		getItems: function() {
			this.loading = true
			return this.$root.request(this, this.request.url, this.request.method, {}, function(
				data
			) {
				this.items = !!this.request.dataSrc ? getProp(data, this.request.dataSrc) : data
				this.updateTbody()
				this.loading = false
			})
		},
		setItems: function() {
			if (!!this.request.url) {
				this.getItems()
			} else if (!!this.datas) {
				this.items = this.datas
				this.updateTbody()
				this.loading = false
			} else {
				this.items = []
				this.updateTbody()
				this.loading = false
			}
		},
		isColumnSorted: function(index) {
			return !!this.getSortedColumn(index)
		},
		getSortedColumn: function(index) {
			return this.ordering.params.find(element => element.index === index)
		},
		toggleSort: function(sort) {
			if (!sort) return 'ASC'

			return sort.toUpperCase() == 'ASC' ? 'DESC' : 'ASC'
		},
		sortColumn: function(index) {
			if (this.isColumnSorted(index)) {
				let column = this.getSortedColumn(index)
				column.sort = this.toggleSort(column.sort)
			} else {
				this.ordering.params = [
					{
						index: index,
						sort: this.toggleSort(false),
					},
				]
			}
		},
		changePage: function(page) {
			this.paging.pages.current = page
		},
		init: function() {
			this.setUrl()
			this.setItems()
		},
		refreshTable: function(related) {
			if (typeof related === 'undefined') related = false

			if (!this.request.url) {
				window.location.reload(true)
			} else {
				this.setItems()
			}

			if (!!this.refTable2 && !related) this.$root.tableRefresh(this.refTable2, true)
		},
		updateFilter: function(type, field, value, update = true) {
			let filter = { ...this.filter }
			if (!filter[field]) filter[field] = {}
			if (!!value) {
				filter[field][type] = value
			} else {
				delete filter[field][type]
			}
			this.filter = filter
			!!update && this.updateTbody()
		},
		filterContains: function(field, value) {
			this.updateFilter('in', field, value)
		},
		filterEquals: function(field, value) {
			this.updateFilter('eq', field, value)
		},
		filterDateFrom: function(field, value) {
			this.updateFilter('from', field, value)
		},
		filterDateTo: function(field, value) {
			this.updateFilter('to', field, value)
		},
		setFilters: function(filters) {
			for (let field in filters) {
				for (let type in filters[field])
					this.updateFilter(type, field, filters[field][type], false)
			}
			this.updateTbody()
		},
	},
	created: function() {
		this.init()
	},
}
</script>
